import { Component, Renderer2 } from '@angular/core';
import { GameHostComponent } from '../game-host/game-host.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../shared/services/spinner.service';
import { Message } from '../shared/model/message';
import { MessageType } from '../shared/model/message-type';
import { GameStatus } from '../shared/model/game-status';
import { WindowsService } from '../shared/services/windows.service';

@Component({
  selector: 'pbg-page-scattergories-host',
  templateUrl: './page-scattergories-host.component.html',
  styleUrls: ['./page-scattergories-host.component.scss']
})
export class PageScattergoriesHostComponent extends GameHostComponent {
  gameResults: any[] = [];
  gamePrefix = 'S';
  categories: string[];

  voteMode = false;
  submitMode = false;
  gameEndMode = false;

  letter: string;
  usersReady = false;

  showUsers = true;

  constructor(
    socketService: SocketService,
    cookieService: CookieService,
    router: Router,
    resolver: ActivatedRoute,
    renderer: Renderer2,
    spinnerService: SpinnerService,
    windowService: WindowsService
  ) {
    super(
      socketService,
      cookieService,
      router,
      resolver,
      renderer,
      spinnerService,
      windowService
    );
  }

  hostMessageHandler(message: Message) {
    super.hostMessageHandler(message);

    if (message.content.status === GameStatus.InProgress) {
      this.inProgressHandler(message);
    } else if (message.content.status === GameStatus.Complete) {
      this.sortUsers();
      this.showUsers = true;
      this.voteMode = false;
      this.submitMode = false;
      this.gameEndMode = true;
    }
  }

  sortUsers() {
    this.connectedUsers = this.connectedUsers.sort(function(a, b) {
      const number1 = a.currentScore;
      const number2 = b.currentScore;

      if (number1 > number2) {
        return -1;
      }

      return 1;
    });
  }

  responseHandler(message: Message) {
    if (message.action === MessageType.Prompt) {
      if (message.content.status === GameStatus.InProgress) {
        this.inProgressHandler(message);
      }
    }
  }

  inProgressHandler(message: Message) {
    this.usersReady = true;
    this.categories = message.content.cattergories;
    this.letter = message.content.letter;
    this.showUsers = false;
    this.voteMode = message.content.voteMode;
    this.submitMode = !this.voteMode;
  }
}
